import React from 'react';
import { useMutation } from '@apollo/client';
import { createQRCodeLink } from 'web-app/react/modals-container/signin-modal/signin-app-helpers';
import { useWhitelabelConfiguration } from 'signin-app/whitelabel/use-whitelabel-configuration';
import * as Queries from './queries';
export const NEW_SECRET_FETCHING_INTERVAL = 900000; // 15 minutes
export const NEW_QR_GENERATING_INTERVAL = 5000;
export const useGenerateQrValue = (institutionId, setQrValue, secret) => {
    const whitelabelConfiguration = useWhitelabelConfiguration();
    const mobileAppUrlScheme = whitelabelConfiguration.MobileAppUrl;
    const generateQrValue = React.useCallback(async () => {
        if (!institutionId || !secret) {
            return;
        }
        const deepLink = await createQRCodeLink(institutionId, secret, mobileAppUrlScheme);
        setQrValue(deepLink);
    }, [institutionId, mobileAppUrlScheme, secret, setQrValue]);
    React.useEffect(() => {
        generateQrValue();
        const newQrValue = setInterval(() => generateQrValue(), NEW_QR_GENERATING_INTERVAL);
        return () => clearInterval(newQrValue);
    }, [generateQrValue]);
};
export const useGenerateSecret = (institutionId, setSecret) => {
    const [getSecret] = useMutation(Queries.GetQrSecret);
    const generateSecret = React.useCallback(async () => {
        var _a, _b, _c, _d, _e, _f;
        if (!institutionId) {
            return;
        }
        const secretData = await getSecret({
            variables: {
                siteId: institutionId,
            },
        });
        if (secretData && ((_c = (_b = (_a = secretData.data) === null || _a === void 0 ? void 0 : _a.qrSignin) === null || _b === void 0 ? void 0 : _b.getSecret) === null || _c === void 0 ? void 0 : _c.secret)) {
            setSecret((_f = (_e = (_d = secretData.data) === null || _d === void 0 ? void 0 : _d.qrSignin) === null || _e === void 0 ? void 0 : _e.getSecret) === null || _f === void 0 ? void 0 : _f.secret);
        }
    }, [getSecret, institutionId, setSecret]);
    React.useEffect(() => {
        generateSecret();
        const newSecret = setInterval(() => generateSecret(), NEW_SECRET_FETCHING_INTERVAL);
        return () => clearInterval(newSecret);
    }, [generateSecret]);
};
